module.exports = __webpack_public_path__ + "static/media/19.21280e56.mp3";